import { render, staticRenderFns } from "./OrteSection.vue?vue&type=template&id=33fb4d08&scoped=true&"
import script from "./OrteSection.vue?vue&type=script&lang=js&"
export * from "./OrteSection.vue?vue&type=script&lang=js&"
import style0 from "./OrteSection.vue?vue&type=style&index=0&id=33fb4d08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fb4d08",
  null
  
)

export default component.exports